import React, { ReactNode } from 'react'
import { LanguageSwitcher } from '../language-switcher'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'

const AuthLayout = ({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) => {
  const { t } = useTranslation('auth')

  return (
    <>
      <Head>
        <title>ALOE - {t(title)}</title>
      </Head>

      <section className="h-screen flex items-center">
        <div className="container max-w-sm mx-auto px-4">
          <div className="mb-24 flex justify-between">
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-primary">ALOE</span>
            </div>
            <LanguageSwitcher />
          </div>
          <article className="mb-8">
            <h3 className="mt-6 text-lg lg:text-2xl">{t(title)}</h3>
            <h5 className="mt-2 text-xs uppercase">
              {t('continue_with_aloe')}
            </h5>
          </article>

          {children}
        </div>
      </section>
    </>
  )
}

export default AuthLayout
